// Persisted sidebar collapsed state. Reads from localStorage on first render
// so the sidebar mounts in its correct state on every page navigation — no
// flash from "open → collapsed" on mobile, no per-page redundant logic.
//
// First-time users get a viewport-aware default: collapsed on mobile,
// expanded on desktop. Subsequent toggles are remembered across sessions.

import { useEffect, useState } from "react";

const STORAGE_KEY = "wi.sidebarCollapsed";

function getInitial() {
  if (typeof window === "undefined") return false;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "1") return true;
    if (stored === "0") return false;
    // No stored preference — default by viewport.
    if (window.matchMedia) {
      return window.matchMedia("(max-width: 767px)").matches;
    }
  } catch {
    /* localStorage may be unavailable in private mode */
  }
  return false;
}

export function useSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState(getInitial);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, collapsed ? "1" : "0");
    } catch {
      /* ignore */
    }
  }, [collapsed]);

  return [collapsed, setCollapsed];
}
